import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/components/ui/dialog';
import { PortalDsButton } from 'src/components/portal-design-system';
import { formatDisplayDateTime } from 'src/helpers/date.helpers';
import type { ClientDataTransfer } from '../types/data-transfers.types';

interface DataTransferRunNowDialogProps {
  transfer: ClientDataTransfer | null;
  open: boolean;
  isRunning?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
}

export function DataTransferRunNowDialog({
  transfer,
  open,
  isRunning = false,
  onOpenChange,
  onConfirm,
}: DataTransferRunNowDialogProps) {
  const nextRunLabel = transfer?.next_run_at
    ? formatDisplayDateTime(transfer.next_run_at)
    : 'not scheduled';

  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent
        className="bg-white sm:max-w-md"
        onClick={(event) => event.stopPropagation()}
      >
        <DialogHeader>
          <DialogTitle>
            Run transfer now?
          </DialogTitle>
          <DialogDescription>
            {transfer
              ? `Run "${transfer.name}" now? This will execute immediately without changing the next scheduled run at ${nextRunLabel}.`
              : 'This will execute immediately without changing the next scheduled run.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <PortalDsButton
            type="button"
            variant="ghost"
            disabled={isRunning}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </PortalDsButton>
          <PortalDsButton
            type="button"
            disabled={isRunning}
            onClick={() => void onConfirm()}
          >
            Run now
          </PortalDsButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
